import { lazy } from "react";
import { RouteProps } from "react-router-dom";

const LookupPage = lazy(() => import("pages/lookup"));
const LookupNotFoundPage = lazy(() => import("pages/404"));

const generalRoutes: RouteProps[] = [
  {
    path: ":id",
    Component: LookupPage,
  },
  {
    path: "404",
    Component: LookupNotFoundPage,
  },
];

export default generalRoutes;
